import axios from "axios";
import { API_URL } from "../config/config";

export const getCall = async (subDirectory, signal = null) => {
  const token = localStorage.getItem("jwt");
  const res = await axios
    .get(API_URL + subDirectory, {
      headers: {
        "Access-Control-Allow-Headers": "*",
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      signal: signal,
    })
    .then(({ data }) => {
      return [data, null];
    })
    .catch((error) => {
      return [null, error.response];
    });
  return res;
};

export const getFileCall = async (subDirectory, signal = null) => {
  const token = localStorage.getItem("jwt");
  try {
    const res = await axios.get(API_URL + subDirectory, {
      headers: {
        "Access-Control-Allow-Headers": "*",
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      signal: signal,
      responseType: "arraybuffer", // Configura el tipo de respuesta esperado (binario)
    });

    return [res.data, null];
  } catch (error) {
    console.error("Error en la llamada GET:", error);
    if (error.response) {
      console.error("Respuesta de error:", error.response);
      return [null, error.response];
    }
    return [null, error];
  }
};

export const postFileCall = async (subDirectory, data, signal = null) => {
  const token = localStorage.getItem("jwt");
  try {
    const res = await axios.post(API_URL + subDirectory, data, {
      headers: {
        "Access-Control-Allow-Headers": "*",
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      signal: signal,
      responseType: "arraybuffer", // Configura el tipo de respuesta esperado (binario)
    });

    return [res.data, null];
  } catch (error) {
    console.error("Error en la llamada GET:", error);
    if (error.response) {
      console.error("Respuesta de error:", error.response);
      return [null, error.response];
    }
    return [null, error];
  }
};

export const postCall = async (subDirectory, data) => {
  const token = localStorage.getItem("jwt");
  const res = await axios
    .post(API_URL + subDirectory, data, {
      headers: {
        "Access-Control-Allow-Headers": "*",
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then(({ data, status }) => {
      return [
        {
          ...data,
          ...(status !== 200 && { status }),
        },
        null,
      ];
    })
    .catch((error) => {
      return [null, error.response];
    });
  return res;
};

export const putCall = async (subDirectory, data) => {
  const token = localStorage.getItem("jwt");
  const res = await axios
    .put(API_URL + subDirectory, data, {
      headers: {
        "Access-Control-Allow-Headers": "*",
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then(({ data }) => {
      return [data, null];
    })
    .catch((error) => {
      return [null, error.response];
    });
  return res;
};

export const deleteCall = async (subDirectory, body = null) => {
  const token = localStorage.getItem("jwt");
  const res = await axios
    .delete(API_URL + subDirectory, {
      headers: {
        "Access-Control-Allow-Headers": "*",
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      ...(body !== null && { data: body }),
    })
    .then((data) => {
      if (data.status === 204 || data.status === 201 || data.status === 200) {
        return [data.statusText, null];
      }
      // return [data, null];
    })
    .catch((error) => {
      return [null, error.response];
    });
  return res;
};

export const postFilesCall = async (subDirectory, files, additionalData) => {
  const token = localStorage.getItem("jwt");

  const data = new FormData();
  files.forEach((file) => {
    data.append(`files`, file);
  });

  if (additionalData) {
    data.append("additional_data", JSON.stringify(additionalData));
  }

  return await axios
    .post(API_URL + subDirectory, data, {
      headers: {
        "Access-Control-Allow-Headers": "*",
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    })
    .then(({ data }) => {
      return [data, null];
    })
    .catch((error) => {
      return [null, error.response];
    });
};

export const sendBeacon = (subDirectory, jsonData) => {
  const data = JSON.stringify({
    ...jsonData,
    token: localStorage.getItem("jwt"),
  });
  const blob = new Blob([data], { type: "application/json" });
  navigator.sendBeacon(API_URL + subDirectory, blob);
};
